import { compose } from 'recompose';

import LabelTimeMessage from './labelTimeMessage';

const enhance = compose();
export default enhance(LabelTimeMessage);
